import { render, staticRenderFns } from "./newUpload.vue?vue&type=template&id=0d983cd6&scoped=true&"
import script from "./newUpload.vue?vue&type=script&lang=js&"
export * from "./newUpload.vue?vue&type=script&lang=js&"
import style0 from "./newUpload.vue?vue&type=style&index=0&id=0d983cd6&lang=scss&scoped=true&"
import style1 from "./newUpload.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d983cd6",
  null
  
)

export default component.exports